import Image from 'next/image';
import { Title, HalfLogo } from 'remote-com-shared/components/CallToAction/Primary';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { LinkButton } from '@/src/components/Button';
import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

const Section = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '50px', '100px')};
  background-color: var(--colors-royalPurple);
  text-align: center;
  position: relative;

  ${Title} {
    margin: 10px auto 30px;
    max-width: 528px;
  }

  ${HalfLogo} {
    ${tabletBreakpoint(css`
      display: none;
    `)}
  }
`;
const CTAButton = styled(LinkButton).attrs({
  withBackground: true,
  textWhite: true,
  chevron: true,
  withBorder: true,
  borderWidth: '2px',
  borderColor: 'turquoise',
})``;

export function PrimaryCtaSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { ctaLabel, headingTitle, ctaLink, flag } = primary;

  return (
    <Section>
      <HalfLogo />
      <ContentContainer>
        <Image
          src={flag?.url}
          alt={flag?.alt || ''}
          width={flag?.dimensions.width}
          height={flag?.dimensions.height}
          quality="100"
        />

        {fieldHasContent(headingTitle) && <Title>{headingTitle}</Title>}

        {ctaLabel && (
          <CTAButton
            href={ctaLink?.url || `${process.env.NEXT_PUBLIC_EMPLOY_BASE_URL}/sign-up`}
            target={ctaLink?.target}
            label={ctaLabel}
          />
        )}
      </ContentContainer>
    </Section>
  );
}
